import React from 'react'
import classes from './Paragraphs.module.css'

const ParagraphsWithVariables = ({ data, className }) => {
  const { paragraph, title, variables } = data
  const parts = paragraph.split(/(\{.*?\})/g)

  const boldOrLink = (index, variable) => {
    let element
    if (variable?.link) {
      element = (
        <a
          key={index}
          className={classes.variableTextLink}
          target="_blank"
          rel="noopener noreferrer"
          href={variable?.link}
        >
          {variable.text}
        </a>
      )
    } else if (variable?.style === 'bold') {
      element = <strong key={index}>{variable.text}</strong>
    } else if (variable?.style === 'underline') {
      element = (
        <span
          key={index}
          style={{ textDecoration: 'underline' }}
        >
          {variable.text}
        </span>
      )
    } else if (variable?.text) {
      element = <span key={index}>{variable.text}</span>
    }
    return element
  }

  const allTextToRender = parts.map((part, index) => {
    if (part.includes('{')) {
      const variable = part.slice(1, -1)
      return boldOrLink(index, variables?.[variable]) ?? part
    } else {
      return part
    }
  })

  return (
    <p className={`${classes.paragraphsDescription} ${className}`}>
      <span className={classes.title}>{title}</span>
      {allTextToRender}
    </p>
  )
}

export default ParagraphsWithVariables
